function getOptionsLockup(options) {
  return options.reduce((acc, item) => {
    if ("group" in item) {
      return { ...acc,
        ...getOptionsLockup(item.items)
      };
    }

    acc[item.value] = item;
    return acc;
  }, {});
}

export { getOptionsLockup };